<template>
  <div class="business-category" :class="categoryClass">
    <div class="category-background"></div>
    <div class="category-content">
      <div class="category-header">
        <h2 class="category-title">{{ title }}</h2>
        <p class="category-description">{{ description }}</p>
      </div>
      <div class="services-content">
        <div 
          v-for="(service, index) in services" 
          :key="index" 
          class="service-item"
        >
          <h3 class="service-title">{{ service.title }}</h3>
          <p class="service-description">{{ service.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusinessCategory',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    services: {
      type: Array,
      required: true
    },
    categoryIndex: {
      type: Number,
      required: true
    },
    backgroundImage: {
      type: String,
      default: ''
    }
  },
  computed: {
    categoryClass() {
      return `category-${this.categoryIndex}`;
    }
  }
};
</script>

<style scoped>
.business-category {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.category-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  z-index: 0;
}

.category-1 .category-background {
  background-image: linear-gradient(rgba(0, 64, 128, 0.75), rgba(30, 64, 175, 0.75)), url('https://pcctc-website.oss-cn-beijing.aliyuncs.com/products/img1.png');
}

.category-2 .category-background {
  background-image: linear-gradient(rgba(102, 126, 234, 0.75), rgba(118, 75, 162, 0.75)), url('https://pcctc-website.oss-cn-beijing.aliyuncs.com/products/img2.png');
}

.category-3 .category-background {
  background-image: linear-gradient(rgba(74, 144, 226, 0.75), rgba(180, 58, 122, 0.75)), url('https://pcctc-website.oss-cn-beijing.aliyuncs.com/products/img3.png');
}

.category-4 .category-background {
  background-image: linear-gradient(rgba(56, 103, 214, 0.75), rgba(99, 39, 120, 0.75)), url('https://pcctc-website.oss-cn-beijing.aliyuncs.com/products/img4.png');
}

.category-5 .category-background {
  background-image: linear-gradient(rgba(30, 60, 114, 0.75), rgba(42, 104, 144, 0.75)), url('https://pcctc-website.oss-cn-beijing.aliyuncs.com/products/img5.png');
}

.category-6 .category-background {
  background-image: linear-gradient(rgba(67, 56, 202, 0.75), rgba(147, 51, 234, 0.75)), url('https://pcctc-website.oss-cn-beijing.aliyuncs.com/products/img6.png');
}

.category-7 .category-background {
  background-image: linear-gradient(rgba(79, 70, 229, 0.75), rgba(165, 39, 116, 0.75)), url('https://pcctc-website.oss-cn-beijing.aliyuncs.com/products/img7.png');
}

.category-content {
  width: 100%;
  padding: 4rem 2rem;
  position: relative;
  z-index: 2;
  max-width: 1400px;
  margin: 0 auto;
}

.category-header {
  text-align: center;
  margin-bottom: 4rem;
}

.category-title {
  font-size: clamp(2rem, 4vw, 3.2rem);
  font-weight: 700;
  color: #fff;
  margin-bottom: 2rem;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
  letter-spacing: 0.5px;
  position: relative;
}

.category-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.4));
  border-radius: 2px;
}

.category-description {
  font-size: clamp(1.1rem, 2vw, 1.4rem);
  color: #f8fafc;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
  max-width: 1000px;
  margin: 0 auto;
  line-height: 1.8;
}

/* 新的文字段落样式 */
.services-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.service-item {
  margin-bottom: 3rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 2.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.service-item:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.service-item:last-child {
  margin-bottom: 0;
}

.service-title {
  font-size: clamp(1.3rem, 2.5vw, 1.8rem);
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 1.5rem 0;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  line-height: 1.4;
}

.service-description {
  font-size: clamp(1rem, 1.8vw, 1.2rem);
  color: #f1f5f9;
  line-height: 1.8;
  margin: 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  text-align: justify;
}

@media (max-width: 1024px) {
  .category-background {
    background-attachment: scroll;
  }
  
  .category-content {
    padding: 3rem 1.5rem;
  }
  
  .service-item {
    padding: 2rem;
    margin-bottom: 2.5rem;
  }
}

@media (max-width: 768px) {
  .category-content {
    padding: 2.5rem 1rem;
  }
  
  .category-header {
    margin-bottom: 3rem;
  }
  
  .service-item {
    padding: 1.5rem;
    margin-bottom: 2rem;
  }
}

@media (max-width: 480px) {
  .category-content {
    padding: 2rem 0.5rem;
  }
  
  .category-header {
    margin-bottom: 2rem;
  }
  
  .service-item {
    padding: 1.2rem;
    margin-bottom: 1.5rem;
  }
  
  .services-content {
    padding: 0 0.5rem;
  }
}
</style>